import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBack from '@material-ui/icons/ArrowBack';
import moment from 'moment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import './DashboardSpaAppointmentView.scss';
import CustomStatusList from '../../../../shared/dashboard/custom-status-list/Custom-Status-List';
import {
  ALL_STATUS_COLOR,
  DASHBOARD_SPA_VIEW,
  DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  SPA_STATUS_DROPDOWN,
} from '../../../../constants/DashboardConst';
import { dashboardSelectedSpaSelector } from '../../../property/propertySlice';
import CustomCalendarView from '../../../../shared/dashboard/custom-calendar-view/Custom-Calendar-View';
import {
  dashboardCalendarTypeSelector,
  dashboardFilterDateSelector,
  setDashboardFilterDate,
} from '../../DashboardSlice';

const DashboardSpaAppointmentView = (props) => {
  const { onViewToggle, allDashboardSpaList, obj } = props;
  const dispatch = useDispatch();
  const calendarRef = useRef();
  const currSelectedSpa = useSelector(dashboardSelectedSpaSelector);
  const date = useSelector(dashboardFilterDateSelector);
  const calendarType = useSelector(dashboardCalendarTypeSelector);
  const [spaAppointment, setSpaAppointment] = useState({
    filterList: [],
    eventList: [],
  });
  const [selectedValue, setSelectedValue] = useState('');

  const filteredList = (dateObj, dashboardSpaList, type) => {
    let appointmentDate = moment(dashboardSpaList.scheduledDate, DATE_FORMAT);
    if (type === 'timeGridDay') {
      const currentDate = moment(dateObj.formatDate, DATE_FORMAT).format('YYYY-MM-DD');
      appointmentDate = moment(dashboardSpaList.scheduledDate, DATE_FORMAT).format('YYYY-MM-DD');
      if (currentDate === appointmentDate) return true;
    } else if (type === 'timeGridWeek') {
      const startDate = moment(dateObj.startDate, DATE_FORMAT);
      const endDate = moment(dateObj.formatDate, DATE_FORMAT);
      if (startDate.isSameOrBefore(appointmentDate) && endDate.isSameOrAfter(appointmentDate))
        return true;
    } else {
      const currentYearMonth = moment(dateObj.formatDate, DATE_FORMAT);
      if (
        currentYearMonth.isSame(appointmentDate, 'month') &&
        currentYearMonth.isSame(appointmentDate, 'year')
      )
        return true;
    }
  };

  const filterEvent = (dateObj, status, type) => {
    const filterList = allDashboardSpaList.filter((dashboardSpaList) => {
      if (dashboardSpaList.spaId === currSelectedSpa.id && status === 'All')
        return filteredList(dateObj, dashboardSpaList, type);
      if (dashboardSpaList.spaId === currSelectedSpa.id && dashboardSpaList.orderStatus === status)
        return filteredList(dateObj, dashboardSpaList, type);
      return false;
    });

    const eventList = filterList?.map((dashboardSpaList) => {
      const appointmentDate = moment(dashboardSpaList.scheduledDate, DATE_FORMAT).format(
        'YYYY-MM-DD',
      );
      const start = `${appointmentDate}T${dashboardSpaList.scheduledTime}`;
      const end = moment(start, DATE_FORMAT)
        .add(dashboardSpaList.treatmentDuration, 'minute')
        .format();
      const getColor = ALL_STATUS_COLOR.find(
        (statusColor) => statusColor.id === dashboardSpaList.orderStatus,
      );
      return {
        title: dashboardSpaList.items[0].name,
        start,
        end,
        extendedProps: {
          type: 'spa',
          sideColor: getColor?.color,
          backgroundColor: getColor?.backGroundColor,
          status: getColor?.id,
          name: dashboardSpaList.guestName,
          appointmentDate,
        },
      };
    });
    setSpaAppointment({ filterList, eventList });
  };

  useEffect(() => {
    filterEvent(date, selectedValue, calendarType);
  }, [allDashboardSpaList]);

  const onChangeDate = (selectedDate, status) => {
    const currentDate = { ...date };
    if (calendarType === 'timeGridWeek') {
      const startDate = moment(selectedDate).startOf('week').format(DISPLAY_DATE_FORMAT);
      const endDate = moment(selectedDate).endOf('week').format(DISPLAY_DATE_FORMAT);
      currentDate.displayDate = `${startDate} to ${endDate}`;
      currentDate.formatDate = moment(endDate, DISPLAY_DATE_FORMAT).format(DATE_FORMAT);
    } else {
      currentDate.displayDate = moment(selectedDate).format(
        calendarType === 'timeGridDay' ? DISPLAY_DATE_FORMAT : 'MMM',
      );
      currentDate.formatDate = moment(selectedDate).format(DATE_FORMAT);
    }
    dispatch(setDashboardFilterDate(currentDate));
    if (calendarRef?.current && calendarRef?.current?.getApi())
      calendarRef?.current?.getApi()?.gotoDate(moment(currentDate.formatDate).format(DATE_FORMAT));
    filterEvent(currentDate, status, calendarType);
  };

  useEffect(() => {
    onChangeDate(moment(), 'All');
    setSelectedValue('All');
  }, []);

  const renderInput = (textFieldProps) => (
    <Button
      variant='outlined'
      color='secondary'
      size='small'
      endIcon={<KeyboardArrowDownIcon />}
      onClick={() => textFieldProps.onClick()}
      className='me-2 date-view'
    >
      {moment(date.formatDate, DATE_FORMAT).format('MMM YYYY')}
    </Button>
  );

  const handleStatusChange = (e) => {
    setSelectedValue(e);
    filterEvent(date, e, calendarType);
  };

  const onClickBack = () => {
    const viewType = obj?.id ? DASHBOARD_SPA_VIEW : null;
    const viewStatus = obj?.id ? true : false;
    const viewObj = obj?.id ? obj : null;
    return onViewToggle(viewType, viewStatus, viewObj);
  };

  return (
    <div className='mw-100 px-0 container'>
      <div className='d-flex align-items-center pb-2'>
        <div className='col d-flex gap-3 align-items-center'>
          <Button
            variant='text'
            color='secondary'
            size='small'
            startIcon={<ArrowBack />}
            onClick={() => onClickBack()}
            className='back-btn me-2'
          >
            Back
          </Button>
          <div className=''>
            <h5 className='m-0'>Appointments</h5>
          </div>
        </div>

        <div className='col d-flex justify-content-end p-0'>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker
              autoOk
              variant='dialog'
              value={moment(date.formatDate, DATE_FORMAT)}
              onChange={(date) => onChangeDate(date, selectedValue)}
              TextFieldComponent={renderInput}
              animateYearScrolling
              DialogProps={{ className: 'date-picker-dashboard-dialog' }}
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
      <div className='card shadow'>
        <div className='col-12 d-flex flex-wrap'>
          <div className='col col-md-4'>
            <CustomStatusList
              dropdownList={SPA_STATUS_DROPDOWN}
              filterList={spaAppointment.filterList}
              idType='spaId'
              countType='activities'
              name='guestName'
              duration='scheduledTime'
              selectedValue={selectedValue}
              handleStatusChange={handleStatusChange}
            />
          </div>
          <div className='col-md-1 line' />
          <div className='col-md-7'>
            <CustomCalendarView
              date={date}
              calendarType={calendarType}
              calendarRef={calendarRef}
              events={spaAppointment.eventList}
              filterEvent={filterEvent}
              selectedValue={selectedValue}
              countTitle='Activities'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSpaAppointmentView;
